import { useEffect } from "react";
import { IoClose } from "react-icons/io5";

const ProfilePictureModal = ({ profilePicture, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 relative">
        <button
          className="absolute top-2 right-2 text-gray-700 hover:text-gray-900"
          onClick={onClose}
          aria-label="Close modal"
        >
          <IoClose className="w-6 h-6" />
        </button>
        <img
          src={profilePicture}
          alt="Profile"
          className="w-64 h-64  object-cover"
        />
      </div>
    </div>
  );
};

export default ProfilePictureModal;